import React, { FC } from "react";
import { VoicePublic } from "../voiceLibrary/public/Index";

/**
 * 音色设计（路由 `/voice-design`）。
 * 当前复用公共音色列表能力，后续可在本目录独立拆分 UI 与数据层。
 */
export const VoiceDesign: FC = () => <VoicePublic />;
